export const ProfileRoutes = {
  PROFILE: '/profile',
  RESET_PASSWORD: '/profile/reset-password',
  PROFILE_RESET_PASSWORD_VERIFY_CODE: '/profile/reset-password/verify-code',
  PROFILE_RESET_AND_CHOOSE_NEW_PASSWORD:
    '/profile/reset-password/choose-new-password',
  MY_CONSENTS: '/profile/consents',
  PAYMENT_DETAILS: '/profile/payment-details',
  EMERGENCY_CONTACT: '/profile/emergencyContact',
  GENDER_DETAILS: '/profile/gender-details',
  CONTACT_INFORMATION: '/profile/contact-information',
  SETTING_PREFERENCES: '/profile/settings-preferences',
  COMMUNICATION_PREFERENCES: '/profile/communication-preferences',
  LANGUAGE: '/profile/language',
  CARE_TEAM: '/profile/care-team',
  PHARMACY: '/profile/pharmacy',
  ID_CARDS: '/profile/id-cards',
  ID_CARD_FILE_VIEW: '/profile/id-cards/:id',
  COVERAGE: '/profile/coverage',
  MVP_STATUS: '/profile/mvp-status'
}

export const GenderIdentities = {
  WOMAN: {
    text: 'profile.genderDetails.genderIdentitiesTypes.woman',
    key: 'Woman'
  },
  MAN: { text: 'profile.genderDetails.genderIdentitiesTypes.man', key: 'Man' },
  TRANSGENDER_WOMAN: {
    text: 'profile.genderDetails.genderIdentitiesTypes.transgenderWoman',
    key: 'Transgender Woman'
  },
  TRANSGENDER_MAN: {
    text: 'profile.genderDetails.genderIdentitiesTypes.transgenderMan',
    key: 'Transgender Man'
  },
  NON_BINARY: {
    text: 'profile.genderDetails.genderIdentitiesTypes.nonBinary',
    key: 'Non-Binary'
  },
  AGENDER: {
    text: 'profile.genderDetails.genderIdentitiesTypes.agender',
    key: 'Agender/I don’t identify with any gender'
  },
  PREFER_NOT_TO_STATE: {
    text: 'profile.genderDetails.genderIdentitiesTypes.preferNotToState',
    key: 'Prefer not to state'
  },
  OTHER: {
    text: 'profile.genderDetails.genderIdentitiesTypes.other',
    key: 'Other'
  }
}

export const BiologicalSex = {
  male: 'profile.genderDetails.biologicalSex.male',
  female: 'profile.genderDetails.biologicalSex.female'
}

export const Pronouns = {
  SHE_HER: { text: 'profile.genderDetails.pronounsTypes.she', key: 'She/Her' },
  HE_HIM: { text: 'profile.genderDetails.pronounsTypes.he', key: 'He/Him' },
  THEY_THEM: {
    text: 'profile.genderDetails.pronounsTypes.they',
    key: 'They/Them'
  },
  ZE_HIR: { text: 'profile.genderDetails.pronounsTypes.ze', key: 'Ze/Hir' }
}
